// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from "vue";
import 'babel-polyfill';
import App from "./App";
import router from "./router";
import store from "./store/index";
import MyQueue from "./utils/queue";
import Toast from "./commonComponents/Toast/toast.js";
import * as filters from './filters'; // 导入全局过滤器

import VueClipboard from "vue-clipboard2";
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();

Object.keys(filters).forEach(key => Vue.filter(key, filters[key])); // 注册过滤器

// 全局组件，按需引入
import "element-ui/lib/theme-chalk/index.css";
import element from "./commonComponents/index";
Vue.use(element);

//动态设置html大小
import "./utils/base.js";
//重置默认样式
import "./styles/reset.css";
// icon样式
import "./assets/fonts/iconfont.css";
import "swiper/swiper.scss";
import dayjs from "dayjs";
import {eventFacebook} from "@/utils/facebook"
Vue.prototype.$eventFacebook = eventFacebook; //facebook埋点
// 导入swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.config.productionTip = false;
//货币金额处理
const currency = require("currency.js");
Vue.prototype.$currency = currency; //赋值使用
Vue.prototype.$moment = dayjs; //赋值使用
//事件队列
Vue.prototype.$myQueue = new MyQueue();
//global event bus
//this.$eventBus.$on  this.$eventBus.$emit
Vue.prototype.$eventBus = new Vue();

Vue.use(Toast); //封装的messagebox组件 通过this调用
Vue.use(VueAwesomeSwiper);
Vue.use(VueClipboard);

import i18n from './utils/i18n'

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js